import { render, staticRenderFns } from "./CardScaffoldManagers.vue?vue&type=template&id=e1b47c3a"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1b47c3a')) {
      api.createRecord('e1b47c3a', component.options)
    } else {
      api.reload('e1b47c3a', component.options)
    }
    module.hot.accept("./CardScaffoldManagers.vue?vue&type=template&id=e1b47c3a", function () {
      api.rerender('e1b47c3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/cards/CardScaffoldManagers.vue"
export default component.exports